// Inscrit la résolution d'impression dans un PNG (chunk pHYs, juste après
// IHDR) : sans elle, un logiciel de mise en page ouvre le fichier à 72 dpi
// (3543 px = 1,25 m de large au lieu de 30 cm). Les pixels ne changent pas.

const CRC_TABLE = (() => {
  const table = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    table[n] = c >>> 0;
  }
  return table;
})();

function crc32(bytes) {
  let crc = 0xffffffff;
  for (const byte of bytes) crc = CRC_TABLE[(crc ^ byte) & 0xff] ^ (crc >>> 8);
  return (crc ^ 0xffffffff) >>> 0;
}

// Signature (8 octets) + IHDR (4 longueur + 4 type + 13 données + 4 CRC).
const IHDR_END = 8 + 4 + 4 + 13 + 4;

export function withPngDpi(png, dpi) {
  const bytes = png instanceof Uint8Array ? png : new Uint8Array(png);
  const pixelsPerMeter = Math.round(dpi / 0.0254);
  const chunk = new Uint8Array(4 + 4 + 9 + 4);
  const view = new DataView(chunk.buffer);
  view.setUint32(0, 9);
  chunk.set([0x70, 0x48, 0x59, 0x73], 4); // "pHYs"
  view.setUint32(8, pixelsPerMeter);
  view.setUint32(12, pixelsPerMeter);
  chunk[16] = 1; // unité : mètre
  view.setUint32(17, crc32(chunk.subarray(4, 17)));

  const out = new Uint8Array(bytes.length + chunk.length);
  out.set(bytes.subarray(0, IHDR_END), 0);
  out.set(chunk, IHDR_END);
  out.set(bytes.subarray(IHDR_END), IHDR_END + chunk.length);
  return out;
}
